import { render, staticRenderFns } from "./BannerSlider.vue?vue&type=template&id=6867111c&scoped=true&"
import script from "./BannerSlider.vue?vue&type=script&lang=js&"
export * from "./BannerSlider.vue?vue&type=script&lang=js&"
import style0 from "./BannerSlider.vue?vue&type=style&index=0&id=6867111c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6867111c",
  null
  
)

export default component.exports